import { Button } from "@mui/material";
import { styled } from "@mui/system";

export const Root = styled(Button)({
  fontSize: 10,
  height: 30,
  placeSelf: "center"
});
